import React from 'react';
import { Loader, LoaderProps } from 'semantic-ui-react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const StyledLoader = styled(Loader)`
  &::after {
    border-color: ${theme.colors.mainBlue} transparent transparent !important;
  }
`;

const LoadingSpinner = ({ children, ...props }: LoaderProps) => (
  <StyledLoader {...props}>{children}</StyledLoader>
);

export default LoadingSpinner;
